import React, { useEffect, useState } from "react";
import { Box, Divider, Grid, IconButton } from "@mui/material";
import CardComponent from "./CardComponent";
import { getFranchiseMachines } from "../../../Services/authService";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import { AddCircleOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import TempImage from "../../../assets/Group.webp";
import { useTranslation } from "react-i18next";

const FranchiseMachine = ({ searchTerm, filterTerm, franchiseId }) => {
  const navigate = useNavigate();
  const { mode } = useThemeContext(); // Access theme context
  const [franchiseMachines, setFranchiseMachines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    const fetchMachines = async () => {
      try {
        setLoading(true);
        const data = await getFranchiseMachines(
          "location",
          searchTerm,
          filterTerm,
        );

        // Map machineType from API response into vendingMachine structure expected by components
        // const transformedData = data.map((franchise) => ({
        //   ...franchise,
        //   machines: (franchise.machines || []).map((machine) => ({
        //     ...machine,
        //     id: machine.machineId || machine.id,
        //     vendingMachine: {
        //       machineType: machine.machineType || "",
        //     },
        //   })),
        // }));

        // If franchiseId is provided, filter the data
        if (franchiseId) {
          const filteredData = data.filter(
            (franchise) =>
              String(franchise.franchiseId) === String(franchiseId),
          );

          setFranchiseMachines(filteredData);
        } else {
          setFranchiseMachines(data);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch machines");
      } finally {
        setLoading(false);
      }
    };

    fetchMachines();
  }, [searchTerm, filterTerm, franchiseId]);

  if (loading)
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          margin: "20px",
          justifyContent: "center",
          alignSelf: "center",
          textAlign: "center",
        }}
      >
        <p>{t("vendingMachines.Loading")}</p>
      </Box>
    );

  if (error)
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          margin: "20px",
          justifyContent: "center",
          alignSelf: "center",
          textAlign: "center",
        }}
      >
        <p>{error}</p>
      </Box>
    );

  const navbarBackground =
    mode === "light" ? LIGHTCOLORS.BackgroundCard : DARKCOLORS.BackgroundCard;
  const addText =
    mode === "light"
      ? LIGHTCOLORS.HeadingLightBackground
      : DARKCOLORS.BaseWhite;

  // No machines in any franchise group for the current search/filter
  // const totalMachines = franchiseMachines.reduce(
  //   (sum, f) => sum + (f.machines?.length || 0),
  //   0,
  // );
  // if (totalMachines === 0)
  //   return (
  //     <Box
  //       sx={{
  //         height: "300px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         fontSize: "18px",
  //         textAlign: "center",
  //         color:
  //           mode === "dark" ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40,
  //       }}
  //     >
  //       {t("vendingMachines.noResultsFound")}
  //     </Box>
  //   );

  // Handle Add Machine
  const handleAddMachine = (franchiseId) => {
    // Navigate to Add Machine page with companyId as props
    navigate("/add-machine", { state: { companyId: franchiseId } });
  };
  return (
    <Box sx={{ width: "100%" }}>
      {franchiseMachines.map((franchise) => (
        <Box key={franchise.franchiseId}>
          <div
            style={{
              display: "flex",
              marginBottom: "15px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                minWidth: 0,
              }}
            >
              <img src={TempImage} />
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <h3
                  className="franchise-heading-text"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    margin: 0,
                  }}
                  title={franchise.franchiseName}
                >
                  {franchise.franchiseName}
                </h3>
              </Box>
            </Box>
            <IconButton
              onClick={() => handleAddMachine(franchise.franchiseId)}
              className="add-machine"
              sx={{
                fontSize: "12px",
                borderRadius: "40px",
                p: "15px 20px",
                backgroundColor: navbarBackground,
                color: addText,
                mx: "7px",
                "&:hover": {
                  backgroundColor: navbarBackground,
                  boxShadow: "none",
                },
              }}
            >
              {t("vendingMachines.add_machine")}{" "}
              <AddCircleOutline fontSize="small" sx={{ marginLeft: "10px" }} />
            </IconButton>
          </div>
          <Divider />
          <Box
            className="franchise-grid"
            sx={{
              marginBottom: "50px",
              marginTop: "25px",
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              },
              gap: 2,
            }}
          >
            {franchise.machines.map((machine) => (
              <CardComponent
                key={machine.id}
                data={{ ...machine, id: machine.machineId }}
                franchise="franchise"
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FranchiseMachine;
